<!--temp-->
<marlenka-coupon-dialog
[reservationService]="reservationService"
></marlenka-coupon-dialog>
